import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1><span>PreciseCA</span> – Scalable Financial Insights for Multi-Branch Businesses</h1>
          <p>
            Multi-branch data collection, consolidation, and reporting are tedious and time-consuming when done manually.
          </p>
          <p className="hero-bold-text">
            <strong>PreciseCA</strong> automates this by syncing complete Tally data from multiple branch locations to deliver deep, accurate multi-branch analytics with secure, role-based access control
          </p>
          <div className="hero-buttons">
            <a href="#contact" className="btn-primary">Start Free Trial – Register now</a>
          </div>
        </div>
        <div className="hero-image">
          <img src="https://preciseca.com/wp-content/uploads/2025/12/Untitled-design-38.png" alt="PreciseCA Dashboard" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
